import { AnimatePresence, MotiView } from "moti";
import React, { ReactNode } from "react";
import { Dimensions } from "react-native";

import {
  AnimationDurations,
  AnimationEasings,
} from "../../../../theme/animations";

/**
 * Handles wrapping our content in an action sheet that covers the majority of the screen
 */
type ActionSheetContentContainerProps = {
  isOpen: boolean;
  isClosing: boolean;
  children: ReactNode;
};
export const ActionSheetContentContainer = ({
  isOpen,
  isClosing,
  children,
}: ActionSheetContentContainerProps) => {
  const heightOffset = Dimensions.get("window").height - 168;
  return (
    <AnimatePresence>
      {isOpen && !isClosing ? (
        <MotiView
          testID="action-sheet-menu-content-container"
          from={{ opacity: 0, top: heightOffset }}
          animate={{ opacity: 1, top: 0 }}
          exit={{ opacity: 0, top: heightOffset }}
          transition={{
            opacity: {
              type: "timing",
              duration: AnimationDurations.moderate02,
              easing: AnimationEasings.standard,
            },
            top: {
              type: "timing",
              duration: AnimationDurations.moderate02,
              easing: AnimationEasings.standard,
            },
          }}
          exitTransition={{
            opacity: {
              type: "timing",
              duration: AnimationDurations.moderate02,
              easing: AnimationEasings.standard,
            },
            top: {
              type: "timing",
              duration: AnimationDurations.moderate02,
              easing: AnimationEasings.standard,
            },
          }}
          style={{
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            bottom: 0,
            position: "relative",
            backgroundColor: "#FFFFFF",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </MotiView>
      ) : null}
    </AnimatePresence>
  );
};
